module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';
	var Promise = fox.RSVP.Promise;

	var storage = new fox.LocalStorageObjectService({
		lsLabel: '_smas_',
		cleanCheckInterval: 1000 * 60 * 60 * 24 * 15
	});

	var result = null;

	function checker (menuItem, key, _this) {
		var storageValue = fox.objectGet(storage.getItem(fox.site.member ? 'blog_member' : 'blog_guest'), 'value');

		if (fox.isUndefined(storageValue)) {
			var dl = fox.createDataLayer().setMethod('blog.get').addFields(['id']).setMetaFields(['totalCount']);
		
			dl._wrappedMethods = {};
			dl.wrapMethod('load');
			dl.setOption('cacheChannel', 'content');

			_this.getEm().handleHook(dl, 'onStartLoad', function () {
				if (!fox.site.member) dl.setTransitParameter('notMember', 1);

				return true;
			}.bind(this));
		} else {
			result = storageValue;
		}
		
		return result === null && new Promise(function (resolve) {
			this.wait(dl, 'loaded').then(function () {
				result = dl.getCount() !== 0;

				storage.setItem(fox.site.member ? 'blog_member' : 'blog_guest', {value: result});

				return resolve(result);
			});

			dl.load();
		}.bind(_this)) || result;
	}

	fox.registerOptions('~.Menu_Main', {
		'pattern.blogChecker.checkers.hasBlogs': {
			callback: checker,
			async: true
		}
	}, 1, {});
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/menu/checkers/blog.js
// module id = 864
// module chunks = 4